// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"243":"835f8ca828d7224602e7","671":"020bfca7ce627b378101"}[chunkId] + ".css";
};